export default "__VITE_ASSET__CxXiqMB0__"